// import data from '@/data/data.ts' use if you have a seperate data file

import { GetterTree } from 'vuex'
import { State } from '.'

const getters: GetterTree<any, any> = {
	loginError(state: State): false | string {
		return state.loginError
	},
	loginMessage(state: State): false | string {
		return state.loginMessage
	},
	preventNavigation(state: State): {prevent: boolean, message?: string} {
		return state.preventNavigation
	}
}

export default getters
